module.exports = __webpack_public_path__ + "static/img/11.4d50f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/11.png
// module id = 929G
// module chunks = 1